import AsyncLoader from 'commons/components/AsyncLoader';

export { CONTENTS_PATH } from './constants';

export default AsyncLoader(() => import('./ContentList'));

export const ContentArchivedList = AsyncLoader(() => import('./ContentArchivedList'));
